module.exports = {
    showStats: false,
    resolution: {width:1024, height:768},
    loadscreen: {
        loadbar:{
            position:{x:398, y:717}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 9
// module chunks = 0